export default __webpack_public_path__ + "static/choreography-dark-30f9b8ddae54b6572616cbebd3cbc3b4.mp4";